var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180 180",
    style: {
      enableBackground: "new 0 0 180 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6F6F6F;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.9,12.8c18.3,0,36,6.5,49.9,18.3h-8.3v2h11.9V21.2h-2v8.5c-14.4-12.3-32.6-19-51.5-19 c-43.7,0-79.2,35.5-79.2,79.2c0,11.7,2.5,22.9,7.4,33.4l1.8-0.8c-4.8-10.2-7.2-21.2-7.2-32.5C12.8,47.3,47.3,12.8,89.9,12.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M161.9,56.7l-1.8,0.8c4.8,10.3,7.2,21.2,7.2,32.6c0,42.6-34.6,77.2-77.2,77.2c-18.3,0-36-6.5-49.9-18.3h8.3v-2 H36.7v11.8h2v-8.5c14.3,12.3,32.5,19,51.5,19c43.6,0,79.1-35.5,79.1-79.2C169.2,78.3,166.8,67.2,161.9,56.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateArrow);
export default __webpack_public_path__ + "static/media/rotate_arrow.afc84ce861fc000256b9c92af32f2a8a.svg";
export { ForwardRef as ReactComponent };